import cx from 'classnames';
import React, { memo } from 'react';
import s from './BLoader.module.scss';

export interface BLoaderProps {
  children?: React.ReactNode;
  className?: string;
}

export const BLoader = memo<BLoaderProps>((props: BLoaderProps) => {
  const { children, className } = props;

  return (
    <div className={cx(s.Bloader, className)}>
      <div className={s.wrapper}>
        <div className={s.contrainer}>
          <div className={s.circle} />
        </div>
        <div className={s.contrainer}>
          <div className={s.circle} />
        </div>
        <div className={s.contrainer}>
          <div className={s.circle} />
        </div>
        <div className={s.contrainer}>
          <div className={s.circle} />
        </div>
        <div className={s.contrainer}>
          <div className={s.circle} />
        </div>
        <div className={s.contrainer}>
          <div className={s.circle} />
        </div>
        <div className={s.contrainer}>
          <div className={s.circle} />
        </div>
      </div>
      {children}
    </div>
  );
});
